import React, { useState } from 'react';
import Main from '../../Main';
import { Button, Col, Dropdown, Form, Row, Tab, Nav } from 'react-bootstrap';
import '../../../assets/css/dashboard.scss';
import '../../../assets/css/customermanagement.scss';
import 'react-datepicker/dist/react-datepicker.css';
import Download from '../../MainSection/Download/Download';
import PurchasingInventoryDataTable from './PurchasingInventoryDataTable';
import AccountingAndCostingTable from './AccountingAndCostingTable';
import MaterialRequirementPlanningTable from './MaterialRequirementPlanningTable';
import SpecialFeaturesTable from './SpecialFeaturesTable';

const MaterialMasterExtended = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [activeKey, setActiveKey] = useState('Purchasing'); // Default active tab

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        showBackButton={true}
                        moduleName="Material Master"
                    />
                </div>
                {/* <div className="customermanagement-content"> */}
                <Row className='m-0 work-queue-tabs'>
                    <Col className='p-0'>
                        <Tab.Container activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                            <Nav variant="tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="Purchasing">
                                        Purchasing /Inventory Data
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item style={{ width: 'max-content' }}>
                                    <Nav.Link eventKey="Mrp">
                                        Material Requirement Planning (MRP 1/2/3/4)
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="AnC">
                                        Accounting & Costing
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="SF">
                                        Special Features
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <div className="customer-management-container">
                                <div className='customermanagement-content-container pt-0'>
                                    <Tab.Content className="customermanagement-content">
                                        <Tab.Pane eventKey="Purchasing">
                                            <PurchasingInventoryDataTable />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="Mrp">
                                            <MaterialRequirementPlanningTable />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="AnC">
                                            <AccountingAndCostingTable />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="SF">
                                            <SpecialFeaturesTable />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </Tab.Container>
                    </Col>
                </Row>

                {/* </div> */}
            </Main>
        </div>
    );
};

export default MaterialMasterExtended;
